import { useFocusInvalidField } from "@shared/hooks/useFocusInvalidField";
import { FormElementAttributes } from "@types";
import { toFarsiNumber } from "@utils/digits";
import classNames from "classnames";
import { Field } from "formik";
import { useFormContext } from "./form-context";

interface Props extends FormElementAttributes {
  hasError?: boolean;
}

const SelectInput: React.FC<Props> = (props) => {
  const {
    commonAttrs,
    classes,
    specificAttrs,
    values: options,
    hasError,
  } = props;
  const { name, id } = commonAttrs;
  const { validate } = useFormContext();
  const multiple = specificAttrs.includes("multiple");
  const { fieldRef } = useFocusInvalidField(name, true);

  return (
    <Field
      as="select"
      name={name}
      validate={(v: any) => validate(name, v)}
      className={classNames(
        classes.join(" "),
        "form-control",
        hasError ? "!mb-2.5" : ""
      )}
      id={id}
      multiple={multiple}
      innerRef={(el: HTMLElement) => {
        fieldRef.current = el;
      }}
    >
      {options.map((op, idx) => (
        <option key={idx} value={op}>
          {toFarsiNumber(op) || "---"}
        </option>
      ))}
    </Field>
  );
};

export default SelectInput;
